import type { HubGuideHud } from "../game/hubs";
import { PANEL } from "./theme";

/** Words for which way the arrow points, for screen readers. */
function whichWay(angle: number): string {
  const a = Math.abs(angle);
  if (a <= 30) return "ahead";
  if (a >= 150) return "behind you";
  return angle > 0 ? "to your right" : "to your left";
}

/**
 * The guide to a hub a goal just unlocked (#87): an arrow that turns to point
 * the way from where the camera looks, the hub's name and how far. Game shows
 * it for a few seconds of free skate, or until you roll into the hub.
 */
export function HubGuide({ guide }: { guide: HubGuideHud }) {
  return (
    <div
      role="status"
      aria-label={`${guide.name} hub: ${guide.meters} meters ${whichWay(guide.angle)}`}
      className={`${PANEL} flex items-center gap-2 px-3 py-1`}
    >
      <span
        aria-hidden="true"
        className="grid size-11 shrink-0 place-items-center rounded-full border-4 border-ink bg-highlight text-2xl font-black leading-none text-ink"
        style={{ transform: `rotate(${guide.angle}deg)` }}
      >
        ↑
      </span>
      <span className="text-left">
        <span className="block text-[11px] font-black uppercase tracking-widest opacity-70">New hub · {guide.meters} m</span>
        <span className="block text-base font-black uppercase italic">{guide.name}</span>
      </span>
    </div>
  );
}
